import {Request} from "../core/request";
import {AuthHeader} from "../core/token";
import {AuthAcademic, AuthAdmin, AuthConsultant, AuthManagerAdmin, AuthTeacher} from "../auth/permissions";

export const AuthOptions = [
    {value: AuthTeacher, label: 'Tutor'}, // 普通老师
    {value: AuthAcademic, label: 'Academic'}, // 学术老师
    {value: AuthAdmin, label: 'Admin'}, // 普通教务
    {value: AuthManagerAdmin, label: 'ManagerAdmin'}, // 管理教务
    {value: AuthConsultant, label: 'Consultant'}, // 教学顾问
];

export type TimeSheet = {
    ID?: number;
    base_id?: string;
    Name?: string,
    Title?: string,
    Remark?: string,
    AllowedAuth?: number,
    StartDate?: string,
    PeriodWeeks?: number,
    GraceDays?: number,
    Questions?: string,


    Version?: string,
    IsOldVersion?: boolean,

}

export interface Working {
    ID: number;
    CreatedAt: string;
    UpdatedAt: string;
    DeletedAt?: string | null;

    // 用户相关字段
    UserId: number;
    UserName: string;
    RemarkName: string;

    // 工时单字段
    TimesheetBaseId: string;
    TimesheetId: number;
    TimesheetName: string;
    TimesheetVersion: number;

    // 回答问题字段
    Answers: string;           // JSON 字符串
    SubmitTime: string;        // ISO 时间字符串
    PeriodStartDate: string;   // ISO 时间字符串
    PeriodEndDate: string;     // ISO 时间字符串
    UpdateGraceDay: string;    // ISO 时间字符串
}


export async function createTimesheets(req: TimeSheet) {
    const resp = await Request.post(`/super_admin/working/timesheets`, {
        name: req.Name,
        title: req.Title,
        remark: req.Remark,
        allowed_auth: req.AllowedAuth,
        start_date: req.StartDate,
        period_weeks: req.PeriodWeeks,
        grace_days: req.GraceDays,
        questions: req.Questions,
    }, {headers: AuthHeader()})
    return resp.data
}

export async function updateTimeSheetQuestions(req: TimeSheet) {
    const resp = await Request.post(`/super_admin/working/timesheets/version`, {
        baseId: req.base_id,
        remark: req.Remark,
        title: req.Title,
        questions: req.Questions,
    }, {headers: AuthHeader()})
    return resp.data
}


export async function deleteTimesheet(req: TimeSheet) {
    const resp = await Request.post(`/super_admin/working/timesheets/delete`, {
        baseId: req.base_id,
    }, {headers: AuthHeader()})
    return resp.data
}


export async function getTimesheets(): Promise<TimeSheet[]> {
    const resp = await Request.get(`/super_admin/working/timesheets`, {headers: AuthHeader()});
    return resp.data
}


// --- 教务查询接口
// 参数类型定义
export interface GetWorkingParams {
    timesheetId?: string;
    remarkName?: string;

    filterId?:string;
    filterStartDate?:string;
    filterEndDate?:string;

    periodStartDate?: string; // 格式: "YYYY-MM-DD"
    periodEndDate?: string;   // 格式: "YYYY-MM-DD"

    page?: number;
    pageSize?: number;
    isUser?: boolean; // 如果需要控制当前用户过滤
}

type GetWorkingPageResponse = {
    data: Working[],
    page: number,
    pageSize: number,
    total: number,
    totalPages: number,
}

// --- 员工工时接口
export async function getWorkingsByTimesheetIdWithUser(params: GetWorkingParams): Promise<GetWorkingPageResponse> {
    const {
        timesheetId,
        periodStartDate,
        periodEndDate,
        page,
        pageSize,
        filterId,
        filterStartDate,
        filterEndDate,
    } = params;

    const queryParams: any = {
        timesheetId: timesheetId,
        filterId: filterId,
        filterStartDate: filterStartDate,
        filterEndDate: filterEndDate,
    };

    if (periodStartDate && periodEndDate) {
        queryParams.periodStartDate = periodStartDate;
        queryParams.periodEndDate = periodEndDate;
    } else {
        if (page) queryParams.page = page;
        if (pageSize) queryParams.pageSize = pageSize;
    }

    const resp = await Request.get<GetWorkingPageResponse>(`/teacher/working/`, {
        headers: AuthHeader(),
        params: queryParams,
    });
    return resp.data;
}

export type createWorkingRequest = {
    timesheet_id: number;
    answers: string; // JSON
    PeriodStartDate: string;
    PeriodEndDate: string;
}

export async function createWorking(request: createWorkingRequest) {
    const resp = await Request.post(`/teacher/working/`, request, {
        headers: AuthHeader(),
    });
    return resp.data;
}


export async function updateWorking(working_id: number, answers: string) {
    const resp = await Request.put(`/teacher/working/${working_id}`, {
        answers: answers,
    }, {
        headers: AuthHeader(),
    });
    return resp.data;
}

export async function deleteWorking(working_id: number) {
    const resp = await Request.delete(`/teacher/working/${working_id}`, {
        headers: AuthHeader(),
    });
    return resp.data;
}

export async function getMyTimesheets(): Promise<TimeSheet[]> {
    const resp = await Request.get(`/teacher/working/timesheets`, {headers: AuthHeader()});
    return resp.data
}

export async function getTimesheetWithWorkingID(working_id: number): Promise<TimeSheet> {
    const resp = await Request.get(`/teacher/working/timesheets/${working_id}`, {headers: AuthHeader()});
    return resp.data
}


// 教务查询工时接口封装
export async function getWorkingByTimesheetId(params: GetWorkingParams): Promise<GetWorkingPageResponse> {
    const {
        timesheetId,
        periodStartDate,
        periodEndDate,
        page,
        pageSize,
        remarkName,
        filterId,
        filterStartDate,
        filterEndDate,
    } = params;

    const queryParams: any = {
        timesheetId: timesheetId,
        remarkName: remarkName,
        filterId: filterId,
        filterStartDate: filterStartDate,
        filterEndDate: filterEndDate,
    };

    if (periodStartDate && periodEndDate) {
        queryParams.periodStartDate = periodStartDate;
        queryParams.periodEndDate = periodEndDate;
    } else {
        if (page) queryParams.page = page;
        if (pageSize) queryParams.pageSize = pageSize;
    }

    const resp = await Request.get<GetWorkingPageResponse>(`/admin_manager/working/`, {
        headers: AuthHeader(),
        params: queryParams,
    });
    return resp.data;
}

export async function getAllTimesheets(): Promise<TimeSheet[]> {
    const resp = await Request.get(`/admin_manager/working/timesheets`, {headers: AuthHeader()});
    return resp.data
}
